import { capitalize } from 'lodash';

// Photo cards show the stored name for fosters too (QA feedback), unlike the rest of the foster Hub.
export function photoPetLabel(photo: { petName?: string | null }, fallback = 'Pet'): string {
  return capitalize(photo.petName?.trim() || fallback);
}

export function photoOriginLabel(photo: { careType?: string | null; awoName?: string | null }): string {
  const awo = photo.awoName || 'shelter';
  return photo.careType === 'Foster' ? `Fostered with ${awo}` : `Adopted from ${awo}`;
}

export function typeformPetName(animal?: { name?: string; careType?: string; animalType?: string }): string {
  if (animal?.careType === 'Foster') {
    return animal.animalType?.toLowerCase() === 'dog' ? 'your foster dog' : 'your foster cat';
  }
  return animal?.name || 'your pet';
}
